module.exports = __webpack_public_path__ + "static/sorrowful_1-de2827f6e65c227434988cb7e8fda2ec.jpg";